import VerticalFAQ from './VerticalFAQ';

export default VerticalFAQ;
